function HierarchyDecorator() {
	
	function attach($scope, params) {
		var element = params.element,
			name = params.name,
			hierarchy = params.hierarchy; 
		
		if ( name === '') 
			name = 'ag_' + $scope.$id ; 

		$scope.hierarchyList = [name] ;  

		$scope.setHierarchy(
			{
			 name : name, 
			 setHierarchyFn : function(parentHierarchy) {
			 		$scope.hierarchyList = parentHierarchy.concat($scope.hierarchyList);
					$scope.HTMLId = $scope.hierarchyList.slice().join('_');
					element.attr('id' , $scope.HTMLId);
					$scope.$emit('element-id-set',element.attr('label-key'), $scope.HTMLId);
				}
			}
		) ; 
	}

	return {
		attach: attach
	}	
}